import React from 'react';
import { useTranslation } from 'react-i18next';
import { openCookiePreferences } from '@/components/consent/openCookiePreferences';
import { consentCopy, getPrivacyPolicyUrl, getRefundPolicyUrl, getTermsUrl, marketingLinkProps } from '@/lib/consent';
import './footer.css';

const Footer: React.FC = () => {
  const { t } = useTranslation('common');
  const currentYear = new Date().getFullYear();
  const privacyUrl = getPrivacyPolicyUrl();
  const termsUrl = getTermsUrl();
  const refundUrl = getRefundPolicyUrl();

  return (
    <footer className="footer">
      <div className="footer__container">
        <nav className="footer__links" aria-label={t('legal')}>
          <a {...marketingLinkProps(privacyUrl)}>{consentCopy.privacyPolicy}</a>
          <a {...marketingLinkProps(termsUrl)}>{consentCopy.terms}</a>
          <a {...marketingLinkProps(refundUrl)}>{consentCopy.refundPolicy}</a>
          <button type="button" className="footer__link-button" onClick={openCookiePreferences}>
            {consentCopy.cookiePreferencesLink}
          </button>
        </nav>
        <span className="footer__copyright">{t('copyright', { year: currentYear })}</span>
      </div>
    </footer>
  );
};

export default Footer;
